import { WaitlistForm } from '../components/WaitlistForm';
import { useInView } from '../lib/useInView';

const perks = [
  'Your first skill check free in beta',
  'Early access invite when we open',
  'Join the first cohort that shapes the product',
];

export const FinalCta = () => {
  const { ref, inView } = useInView<HTMLElement>({ threshold: 0.25, once: true });

  return (
    <section
      ref={ref}
      className={`section final${inView ? ' final--revealed' : ''}`}
      id="waitlist"
      aria-labelledby="final-title"
    >
      <div className="container final__inner">
        <div>
          <p className="eyebrow">Next step</p>
          <h2 id="final-title">Measure your real skill. Trust yourself — not just AI.</h2>
          <p className="final__sub">
            Join the waitlist. Get invited when beta opens. No charge, no recruiters, no spam — just
            a practice coach that makes you think for yourself.
          </p>

          <div className="final__form">
            <WaitlistForm
              source="final-cta"
              cta="Save my seat"
              hint="Free beta. Leave whenever you want."
              compact
            />
          </div>
        </div>

        <ul className="final__perks" aria-label="What you get for joining">
          {perks.map((p) => (
            <li key={p} className="final__perk">
              {p}
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};
